import * as React from 'react';
import Cookies from 'js-cookie';
import { withRouter, RouteComponentProps } from 'react-router';
import AuthContext from 'Context/AuthContext';
import { LogoutHandler } from '.';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ConfigUtility from 'Core/ConfigUtility';
import { keys } from 'lodash';

export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}
export interface State {
  isLogout: boolean;
}

export class LogoutWithoutRouter extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  logoutHandler: LogoutHandler;

  constructor(props: Props) {
    super(props);
    this.logoutHandler = new LogoutHandler(props);
    this.state = { isLogout: false };
  }

  async removeRetainBOLCookie() {
    const config = await ConfigUtility.get();
    const cookies = Cookies.get();
    Object.keys(cookies).forEach((key: string) => {
      if (key.includes(config.RetainBOLsCookieName)) {
        Cookies.remove(key);
      }
    });
  }

  componentDidMount() {
    this.logoutHandler.RequesLogout().finally(() => {
      this.removeRetainBOLCookie();
      this.context.Update(undefined);
      this.setState({ isLogout: true });
    });
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Logout</title>
        </Helmet>

        {!this.state.isLogout ? (
          <div>Logging out...</div>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: this.props.location, noPermission: false },
            }}
          />
        )}
      </>
    );
  }
}

const Logout = withRouter(LogoutWithoutRouter);
export default Logout;
